/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayByPlayModelGameDto } from '../../models/play-by-play-model-game-dto';
import { ScoutingEventsRequestDto } from '../../models/scouting-events-request-dto';

export interface ScoutingControllerGetEventsWithVideoExternal$Params {
      body: ScoutingEventsRequestDto
}

export function scoutingControllerGetEventsWithVideoExternal(http: HttpClient, rootUrl: string, params: ScoutingControllerGetEventsWithVideoExternal$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayByPlayModelGameDto>>> {
  const rb = new RequestBuilder(rootUrl, scoutingControllerGetEventsWithVideoExternal.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PlayByPlayModelGameDto>>;
    })
  );
}

scoutingControllerGetEventsWithVideoExternal.PATH = '/scouting/external/events';
